import script from "./VendorPlatforms.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorPlatforms.vue?vue&type=script&setup=true&lang=js"

import "./VendorPlatforms.vue?vue&type=style&index=0&id=4b72d23e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b72d23e"]])

export default __exports__